import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { OwnershipLevel } from '@fitness-force/enum';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/errors';
import { Automation, Campaign, CampaignById, CampaignRequest, CreateAutomation, EmailTemplateMasterById, EmailTemplateMasterResponse, NotificationMasterResponse, UpdateAutomation } from '@fitness-force/models';
import { environment } from 'apps/ff-frontend/src/environments/environment';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {

  constructor(private http: HttpClient, private router: Router) { }
  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  

  CreateCampaigns(payload:CampaignRequest[]): Observable<any> {
    const url = `${environment.BASE_URL}/company/campaign`
    return this.http.post(url, payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetCampaignById(tenantId:number, campaignId:number): Observable<CampaignById> {
    const url = `${environment.BASE_URL}/tenants/${tenantId}/campaigns/${campaignId}`
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetCampaignList(tenantId:number,allparams: any): Observable<Campaign> {
    let parsedParams = new HttpParams()
    allparams.forEach((p: any) => {
      parsedParams = parsedParams.append(p.name, p.value);
    });
    const url = `${environment.BASE_URL}/tenants/${tenantId}/campaigns`
    return this.http.get(url, {
      headers: this.httpOptions.headers,params: parsedParams
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetAutomationList(ownershiplevel: OwnershipLevel,tenantId:number= 0,franchiseId:number=0): Observable<any> {
    let url:string="";
    if(ownershiplevel == OwnershipLevel.Tenant) 
     url = `${environment.BASE_URL}/company/automation/ownership/tenant/${tenantId}`
    if(ownershiplevel == OwnershipLevel.Company) 
     url = `${environment.BASE_URL}/company/automation/ownership/company`
    if(ownershiplevel == OwnershipLevel.Franchise) 
    url = `${environment.BASE_URL}/company/automation/ownership/franchise/${franchiseId}`
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  CreateAutomation(payload:CreateAutomation[]): Observable<any> {
    const url = `${environment.BASE_URL}/company/automation`
    return this.http.post(url, payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  } 

  UpdateAutomation(guid:string, payload:UpdateAutomation): Observable<any> {
    const url = `${environment.BASE_URL}/company/automation/${guid}`
    return this.http.put(url, payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  updateAutomationStatus(guid: string, status: string): Observable<any> {
    const activeUrl = `${environment.BASE_URL}/company/automation/${guid}/mark_as_active`;
    const inactiveUrl = `${environment.BASE_URL}/company/automation/${guid}/mark_as_inactive`;
    const url = status.toLowerCase() === 'active' ? activeUrl : inactiveUrl;
    return this.http.post(url, { headers: this.httpOptions.headers }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        } 
        return throwError(() => new AppErrors(error));
      })
    );
  }

  updateCampaignStatus(guid: string, status: string): Observable<any> {
    const activeUrl = `${environment.BASE_URL}/company/campaign/${guid}/mark_as_active`;
    const inactiveUrl = `${environment.BASE_URL}/company/campaign/${guid}/mark_as_inactive`;
    const url = status.toLowerCase() === 'active' ? activeUrl : inactiveUrl;
    return this.http.post(url, { headers: this.httpOptions.headers }).pipe(
      map((res: any) => {
        return res;
        }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  stopCampaign(campaignGuid :string): Observable<any> {
    const url = `${environment.BASE_URL}/company/campaign/${campaignGuid}/mark_as_stop`;
    return this.http.post(url, { headers: this.httpOptions.headers }).pipe( 
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  voidCampaign(campaignGuid :string): Observable<any> {
    const url = `${environment.BASE_URL}/company/campaign/${campaignGuid}/mark_as_void`;
    return this.http.post(url, { headers: this.httpOptions.headers }).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  CreateWebhookAutomation(ownership:OwnershipLevel,tenantId:number,franchiseId:number, payload:any): Observable<any> {
    let url:string="";
    switch(ownership){
      case OwnershipLevel.Tenant:
        url = `${environment.BASE_URL}/tenants/${tenantId}/webhook-automation`
        break;
      case OwnershipLevel.Company:
        url = `${environment.BASE_URL}/companies/webhook-automation`
        break;  
      case OwnershipLevel.Franchise:
        url = `${environment.BASE_URL}/franchise_group/${franchiseId}/webhook-automation`
        break;
      default:
        url = `${environment.BASE_URL}/tenants/${tenantId}/webhook-automation`
        break;
    }
    return this.http.post(url, payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res  
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error)) 
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

}
